// Models
/** Type of an experiment */ export var CopyMoveCustomizerMode = /*#__PURE__*/ function(CopyMoveCustomizerMode) {
    /** Copy task */ CopyMoveCustomizerMode[CopyMoveCustomizerMode["Copy"] = 0] = "Copy";
    /** Move task */ CopyMoveCustomizerMode[CopyMoveCustomizerMode["Move"] = 1] = "Move";
    return CopyMoveCustomizerMode;
}({});
